import { render, staticRenderFns } from "./customerSegmentsTab.vue?vue&type=template&id=729120b1"
import script from "./customerSegmentsTab.vue?vue&type=script&lang=js"
export * from "./customerSegmentsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports